import { G } from "../theme";

export default function Avatar(props) {
  var bg = props.bg || G;
  var sz = props.size || 36;

  if (props.src) {
    return (
      <img
        src={props.src}
        alt="avatar"
        style={{ width:sz, height:sz, borderRadius:"50%", objectFit:"cover", border:"1.5px solid "+bg }}
      />
    );
  }

  return (
    <div style={{
      width:sz, height:sz, borderRadius:"50%", background:bg+"33", border:"1.5px solid "+bg,
      display:"flex", alignItems:"center", justifyContent:"center",
      fontSize:sz*0.35, fontWeight:600, color:bg, flexShrink:0
    }}>
      {props.s}
    </div>
  );
}
